module.exports = __webpack_public_path__ + "img/step2-no.ceec82b1.png";